<template>
  <div class="animated fadeIn">
    <Row>
      <Input size="small" search @on-search="onFilterClick" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectCreateDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
        <Button  size="small" type="primary">
          <!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="setupDatetime">安装时间</DropdownItem>
          <DropdownItem name="receptDatetime">收款时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Button size="small" type="primary" style="margin-right: 3px;" @click="addInstallOrderModal=true">添加安装订单</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="addReplaceDeviceOrderModal=true">在网升级订单</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onImportOrders">导入订单</Button>
      <Button type="primary" size="small" @click="onExportExcel">导出报表</Button>

<!--      <Button size="small" type="primary" @click="onTest">测试</Button>-->
<!--      <Input size="small" style="width: 200px;margin-right: 3px;margin-left: 20px" v-model="inquireOperationId" placeholder="请输入完整车牌号"></Input>-->
<!--      <Button size="small" type="primary" style="margin-right: 3px;" @click="inquireOperationModal = true">保险免费资格查询</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="false" :data="content"
                 ref="table" :row-class-name="rowClassName"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)">
          </Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <Modal v-model="reqParams.setInsuranceVideoCommitment" title="导出保险行业安装承诺函" @on-ok="onOkInsuranceVideoCommitment" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="reqParams.installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="设备厂商">
          <Select style="display: inline-block; width: 200px;" v-model="reqParams.manufacturer">
            <Option v-for="item in manufacturerpubTypeOptions" :value="item.value" :key="item.value">{{item.name}}</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Checkbox size="small" style="margin-left: 60px;" v-model="reqParams.isall">是否导出完整文档</Checkbox>
        </Form-item>
      </Form>
    </Modal>
    <add-install-order-modal v-model="addInstallOrderModal" @on-success="onSuccess"></add-install-order-modal>

    <install-order-detail-modal v-model="installOrderDetailModal" :initValue="installOrderDetailId"
                                @on-success="onModifySuccess"></install-order-detail-modal>
    <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                    @on-success="onModifySuccess"></bind-positioning-devices-modal>
    <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal" :initValue="bindPositioningDevicesFittingsId"
                                             @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
    <change-installer-modal v-model="changeInstallerModal" :initValue="changeInstallerId"
                            @on-success="onModifySuccess"></change-installer-modal>
    <confirm-recept-modal v-model="confirmReceptModal" :initValue="confirmReceptId"
                          @on-success="onModifySuccess"></confirm-recept-modal>
    <confirm-installed-modal v-model="confirmInstalledModal" :initValue="confirmInstalledId"
                             @on-success="onModifySuccess"></confirm-installed-modal>
    <temp-vehicle-picture-modal v-model="tempVehiclePictureModal" :initValue="tempVehiclePictureId"
                                @on-success="onModifySuccess"></temp-vehicle-picture-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <install-order-base-detail-modal v-model="installOrderBaseDetailModal" :initValue="installOrderBaseDetailId"
                                     @on-success="onModifySuccess"></install-order-base-detail-modal>
    <export-vehicle-cert-modal v-model="exportVehicleCertModal" :installed="exportVehicleCertInstalled"
                               :initValue="exportVehicleCertId"></export-vehicle-cert-modal>
    <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns" :tableName="$options.name"
                             @on-column-update="onColumnUpdate"></web-table-columns-modal>
    <install-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId"
                                              @on-success="onModifySuccess"></install-order-change-business-user-modal>
    <install-order-picture-modal v-model="installOrderPictureModal" :initValue="installOrderPictureModalId"></install-order-picture-modal>
    <add-replace-device-order-modal v-model="addReplaceDeviceOrderModal" @on-success="onSuccess"></add-replace-device-order-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <vehicle-identificationcode-modal v-model="vehicleIdentificationcodeModal" :installed="vehicleIdentificationcodeInstalled"
                                      :initValue="vehicleIdentificationcodeId" @on-success="onSuccess"></vehicle-identificationcode-modal>
<!--    <inquire-operation-modal v-model="inquireOperationModal" :initValue="inquireOperationId"></inquire-operation-modal>-->
  </div>
</template>

<script>
import AddInstallOrderModal from '@/view/om/components/add-install-order-modal'
import InstallOrderDetailModal from '@/view/om/components/install-order-detail-modal'
import InstallOrderBaseDetailModal from '@/view/om/components/install-order-base-detail-modal'
import BindPositioningDevicesModal from '@/view/om/components/bind-positioning-devices-modal'
import ChangeInstallerModal from '@/view/om/components/change-installer-modal'
import ConfirmReceptModal from '@/view/om/components/confirm-recept-modal'
import ConfirmInstalledModal from '@/view/om/components/confirm-installed-modal'
import TempVehiclePictureModal from '@/view/om/components/temp-vehicle-picture-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import ExportVehicleCertModal from '@/view/crm/components/export-vehicle-cert-modal'
import InstallOrderChangeBusinessUserModal from '@/view/om/components/install-order-change-business-user-modal'
import InstallOrderPictureModal from '@/view/om/components/install-order-picture-modal'
import BindPositioningDevicesFittingsModal from '@/view/om/components/bind-positioning-devices-fittings-modal'
import AddReplaceDeviceOrderModal from '@/view/om/components/add-replace-device-order-modal'
import VehiclePictureModal from '@/view/crm/components/vehicle-picture-modal'
import VehicleIdentificationcodeModal from '@/view/crm/components/vehicle-identificationcode-modal'
// import InquireOperationModal from '@/view/crm/components/inquire-operation-modal'

// import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import axios from '@/libs/api.request'

export default {
  name: 'installorders',
  components: {
    AddInstallOrderModal,
    InstallOrderDetailModal,
    BindPositioningDevicesModal,
    ChangeInstallerModal,
    ConfirmReceptModal,
    ConfirmInstalledModal,
    TempVehiclePictureModal,
    VehicleInfoDetailModal,
    InstallOrderBaseDetailModal,
    ExportVehicleCertModal,
    InstallOrderChangeBusinessUserModal,
    InstallOrderPictureModal,
    BindPositioningDevicesFittingsModal,
    AddReplaceDeviceOrderModal,
    VehiclePictureModal,
    VehicleIdentificationcodeModal
    // InquireOperationModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      selectCreateDatetime: [],
      stateFilter: null,
      installedFilter: null,
      qghyptOptionFilter: null,
      uploadStateFilter: null,
      receptFilter: null,
      installerFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      isfreeTypeFilter: null,
      gdcdgovVehicleStateFilter: null,
      FilterClickFilter: null,
      timeoutLogoFilter: null,

      installers: [],
      marketsales: [],
      allSalesChannels: [],

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertInstalled: false,

      // 车辆识别码
      vehicleIdentificationcodeModal: false,
      vehicleIdentificationcodeId: null,
      vehicleIdentificationcodeInstalled: false,

      // 订单基本信息
      installOrderBaseDetailModal: false,
      installOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,
      registrationNum: null,

      // 临时车辆资料图片管理
      tempVehiclePictureModal: false,
      tempVehiclePictureId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 车辆安装图片管理
      installOrderPictureModal: false,
      installOrderPictureModalId: null,

      // 确认收款
      confirmReceptModal: false,
      confirmReceptId: null,

      // 确认安装
      confirmInstalledModal: false,
      confirmInstalledId: null,

      // 指派安装员
      changeInstallerModal: false,
      changeInstallerId: null,

      // 安装订单配置设备
      bindPositioningDevicesModal: false,
      bindPositioningDevicesId: null,

      // 安装订单配置定位设备配件
      bindPositioningDevicesFittingsModal: false,
      bindPositioningDevicesFittingsId: null,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加订单
      addInstallOrderModal: false,

      // 添加在网升级订单
      addReplaceDeviceOrderModal: false,

      // 安装订单详细信息
      installOrderDetailModal: false,
      installOrderDetailId: null,

      // // 保险免费资格查询
      // inquireOperationModal: false,
      // inquireOperationId: null,

      // 保险承诺函
      reqParams: {
        setInsuranceVideoCommitment: false,
        installDatetime: null,
        registrationNum: null,
        id: null,
        isall: false,
        manufacturer: 1
      },

      manufacturerpubTypeOptions: [
        { name: '深圳市锐明技术股份有限公司', value: 1 },
        { name: '江苏市中天安驰科技有限公司', value: 2 }
      ],

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        installOrderId: null
      },

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      // columnsDisplay: [],
      // columnHeaders: [],
      columns: [
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let identificationCode = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              identificationCode = params.row.vehicleInfo.identificationCode === null ? '无' : params.row.vehicleInfo.identificationCode
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            } else {
              registrationNum = params.row.tempVehicleInfo.registrationNum === null ? '无' : params.row.tempVehicleInfo.registrationNum
              identificationCode = params.row.tempVehicleInfo.identificationCode === null ? '无' : params.row.tempVehicleInfo.identificationCode
              vin = params.row.tempVehicleInfo.vin === null ? '无' : params.row.tempVehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum + '(识别码:' + identificationCode + ')'),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '公司资料',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleInfoGroup) {
              return h('div', '公司名称:' + params.row.vehicleInfoGroup.name)
            } else {
              return h('div', '无')
            }
          }
        },
        // {
        //   title: '广东省厅数据状态',
        //   resizable: true,
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 190,
        //   filters: [
        //     { label: '无资料', value: 0 },
        //     { label: '正常', value: 1 },
        //     { label: '运营商不符', value: 2 },
        //     { label: '非营运', value: 3 },
        //     { label: '定位时间不符', value: 4 },
        //     { label: '非运政车辆', value: 5 }
        //   ],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       this.gdcdgovVehicleStateFilter = []
        //       val.forEach(item => {
        //         this.gdcdgovVehicleStateFilter.push(genQueryParam('vehicleInfo.gdcdgovVehicleState', 'EQ', item))
        //       })
        //     } else {
        //       this.gdcdgovVehicleStateFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: (h, params) => {
        //     if (params.row.vehicleInfo) {
        //       let gdcdgovVehicleState = params.row.vehicleInfo.gdcdgovVehicleState
        //       if (gdcdgovVehicleState === 0) {
        //         return h('div', '无资料')
        //       } else if (gdcdgovVehicleState === 1) {
        //         return h('div', '正常')
        //       } else if (gdcdgovVehicleState === 2) {
        //         return h('div', '运营商不符')
        //       } else if (gdcdgovVehicleState === 3) {
        //         return h('div', '非营运')
        //       } else if (gdcdgovVehicleState === 4) {
        //         return h('div', '定位时间不符')
        //       } else if (gdcdgovVehicleState === 5) {
        //         return h('div', '非运政车辆')
        //       }
        //     } else {
        //       return h('label', '未安装')
        //     }
        //   }
        // },
        {
          title: '加急订单',
          resizable: true,
          key: 'urgent',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            const urgent = params.row.urgent
            if (urgent != null) {
              if (urgent) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '加急')
                ])
              } else {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '普通')
                ])
              }
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '指派', value: 1 },
            { label: '完成', value: 2 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 },
            { label: '审核', value: 3 },
            { label: '配货', value: 4 },
            { label: '安装', value: 5 },
            { label: '回访', value: 6 },
            { label: '收款', value: 7 }
          ],
          filterMultiple: true,
          filteredValue: [1, 2, 3, 4, 5, 6, 7],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (params.row.setupDatetime != null) {
              state = 5
            }
            if (state === 1) {
              if (params.row.installer != null) {
                step = 2
              }
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待指派')
              } else if (step === 2) {
                return h('div', '已指派')
              } else if (step === 3) {
                return h('div', '指派失败')
              }
            } else if (state === 2) {
              return h('div', '完成')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            } else if (state === 3) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待配货')
              } else if (step === 2) {
                return h('div', '已配货')
              } else if (step === 3) {
                return h('div', '配货失败')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待安装')
              } else if (step === 2) {
                return h('div', '已安装')
              } else if (step === 3) {
                return h('div', '安装失败')
              }
            } else if (state === 6) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 7) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '超时',
          resizable: true,
          key: 'timeoutLogo',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '未超时', value: 0 },
            { label: '已超时', value: 1 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.timeoutLogoFilter = []
              val.forEach(item => {
                if (item == 1) {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', true))
                } else {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', false))
                }
              })
            } else {
              this.timeoutLogoFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.timeoutLogo) {
              return h('div', '已超时')
            } else {
              return h('div', '未超时')
            }
          }
        },
        {
          title: '预约信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 240,
          render: (h, params) => {
            let bookingDatetime
            let bookingPlace
            let actualDatetime
            let actualPlace
            if (params.row.actualDatetime) {
              if (params.row.actualDatetime) {
                actualDatetime = new Date(params.row.actualDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                actualDatetime = '无'
              }
              if (params.row.actualPlace) {
                actualPlace = params.row.actualPlace
              } else {
                actualPlace = '无'
              }
              return h('div', [
                h('div', '重新预约时间:' + actualDatetime),
                h('div', '重新预约地点:' + actualPlace)
              ])
            } else {
              if (params.row.bookingDatetime) {
                bookingDatetime = new Date(params.row.bookingDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                bookingDatetime = '无'
              }
              if (params.row.bookingPlace) {
                bookingPlace = params.row.bookingPlace
              } else {
                bookingPlace = '无'
              }
              return h('div', [
                h('div', '预约时间:' + bookingDatetime),
                h('div', '预约地点:' + bookingPlace)
              ])
            }
          }
        },
        // {
        //   title: '配机',
        //   resizable: true,
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 100,
        //   render: (h, params) => {
        //     if (params.row.positioningDeviceInfosCount && params.row.positioningDeviceInfosCount > 0) {
        //       return h('div', {
        //         style: {
        //           color: 'green'
        //         }
        //       }, '已分配')
        //     } else {
        //       return h('div', {
        //         style: {
        //           color: 'red'
        //         }
        //       }, '未分配')
        //     }
        //   }
        // },
        {
          title: '安装员',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 100,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.installerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.installerFilter.push(genQueryParam('installerId', 'EQNULL'))
                } else {
                  this.installerFilter.push(genQueryParam('installerId', 'EQ', item))
                }
              })
            } else {
              this.installerFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.installer) {
              let name = null
              if (params.row.installer.realName != null) {
                name = params.row.installer.realName
              } else if (params.row.installer.nickName != null) {
                name = params.row.installer.nickName
              } else if (params.row.installer.name != null) {
                name = params.row.installer.name
              }
              return h('div', name)
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未分配')
            }
          }
        },
        {
          title: '协助安装人员',
          resizable: true,
          key: 'installers',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            if (params.row.installers) {
              let name = params.row.installers
              // if (params.row.installer.realName) {
              //   name = params.row.installer.realName
              // } else if (params.row.installer.nickName) {
              //   name = params.row.installer.nickName
              // } else if (params.row.installer.name) {
              //   name = params.row.installer.name
              // }
              return h('div', name)
            } else {
              return h('div', '无')
            }
          }
        },
        // {
        //   title: '安装状态',
        //   resizable: true,
        //   key: 'installed',
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 120,
        //   filters: [
        //     { label: '未安装', value: 0 },
        //     { label: '安装完成', value: 1 }
        //   ],
        //   filterMultiple: false,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       if (val[0] === 1) {
        //         this.installedFilter = genQueryParam('installed', 'EQBOOL', true)
        //       } else {
        //         this.installedFilter = genQueryParam('installed', 'EQBOOL', false)
        //       }
        //     } else {
        //       this.installedFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: (h, params) => {
        //     if (params.row.installed) {
        //       return h('div', {
        //         style: {
        //           color: 'green'
        //         }
        //       }, '安装完成')
        //     } else {
        //       return h('div', {
        //         style: {
        //           color: 'red'
        //         }
        //       }, '未安装')
        //     }
        //   }
        // },
        // {
        //   title: '安装时间',
        //   resizable: true,
        //   key: 'setupDatetime',
        //   ellipsis: 'true',
        //   sortable: 'custom',
        //   width: 130,
        //   render: function (h, params) {
        //     if (params.row.setupDatetime) {
        //       let d = new Date(params.row.setupDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
        //     } else {
        //       return h('div', {
        //         style: {
        //           color: 'red'
        //         }
        //       }, '无')
        //     }
        //   }
        // },
        // {
        //   title: '上传货运类型',
        //   resizable: true,
        //   key: 'qghyptOption',
        //   ellipsis: 'true',
        //   width: 130,
        //   filters: [
        //     { label: '不需上传', value: 0 },
        //     { label: '新车上传', value: 1 },
        //     { label: '旧车转网', value: 2 }
        //   ],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       this.qghyptOptionFilter = []
        //       val.forEach(item => {
        //         this.qghyptOptionFilter.push(genQueryParam('qghyptOption', 'EQ', item))
        //       })
        //     } else {
        //       this.qghyptOptionFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: (h, params) => {
        //     let qghyptOption = params.row.qghyptOption
        //     if (qghyptOption === 0) {
        //       return h('div', '不需上传')
        //     } else if (qghyptOption === 1) {
        //       return h('div', '新车上传')
        //     } else if (qghyptOption === 2) {
        //       return h('div', '旧车转网')
        //     }
        //   }
        // },
        {
          title: '缺少资料',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 300,
          render: (h, params) => {
            let qghyptOption = params.row.qghyptOption
            let text = ''
            if (qghyptOption === 0) {
              if (!params.row.tempVehicleInfo.vehicleLicensePictureId) {
                text = '行驶证'
              }
              if (!params.row.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                text = text + ' 行驶证副页'
              }
            } else if (qghyptOption === 1) {
              if (!params.row.tempVehicleInfo.vehicleLicensePictureId) {
                text = '行驶证'
              }
              if (!params.row.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                text = text + ' 行驶证副页'
              }
              // 修改资料要求 2023-08-09
              // if (!params.row.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
              //   text = text + ' 登记证1'
              // }
            } else if (qghyptOption === 2) {
              if (!params.row.tempVehicleInfo.vehicleLicensePictureId) {
                text = '行驶证'
              }
              if (!params.row.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                text = text + ' 行驶证副页'
              }
              // 修改资料要求 2023-08-09
              // if (!params.row.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
              //   text = text + ' 登记证1'
              // }
              if (!params.row.tempVehicleInfo.idFilePictureId) {
                text = text + ' 身份识别文件'
              }
              if (!params.row.tempVehicleInfo.idFileBackPictureId) {
                text = text + ' 身份识别文件背面'
              }
              // 修改资料要求 2023-08-09
              // if (!params.row.tempVehicleInfo.qghyptChangeContractPictureId) {
              //   text = text + ' 转网合同'
              // }
              // 修改资料要求 2023-08-09
              // if (!params.row.tempVehicleInfo.qghyptChangeAuthorizationPictureId) {
              //   text = text + ' 授权书'
              // }
            }
            return h('div', {
              style: {
                color: 'red'
              }
            }, text)
          }
        },
        {
          title: '上传状态',
          resizable: true,
          key: 'uploadState',
          tooltip: 'true',
          ellipsis: 'true',
          width: 130,
          filters: [
            { label: '资料不完整', value: 1 },
            { label: '待上传', value: 2 },
            { label: '已上传', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.uploadStateFilter = []
              val.forEach(item => {
                this.uploadStateFilter.push(genQueryParam('uploadState', 'EQ', item))
              })
            } else {
              this.uploadStateFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let uploadState = params.row.uploadState
            if (uploadState === 1) {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '资料不完整')
            } else if (uploadState === 2) {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '待上传')
            } else if (uploadState === 3) {
              return h('div', {
                style: {
                  color: 'green'
                }
              }, '已上传')
            }
          }
        },
        {
          title: '应收总金额',
          resizable: true,
          key: 'totalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 100
        },
        {
          title: '开票类型',
          resizable: true,
          key: 'billType',
          width: 140,
          filters: [
            { label: '增值税发票', value: 1 },
            { label: '增值税专用发票', value: 2 },
            { label: '增值税普通发票', value: 3 },
            { label: '增值税电子专用发票', value: 4 },
            { label: '增值税电子普通发票', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.billTypeFilter = []
              val.forEach(item => {
                this.billTypeFilter.push(genQueryParam('billType', 'EQ', item))
              })
            } else {
              this.billTypeFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let billType = params.row.billType
            if (billType === 1) {
              return h('div', '增值税发票')
            } else if (billType === 2) {
              return h('div', '增值税专用发票')
            } else if (billType === 3) {
              return h('div', '增值税普通发票')
            } else if (billType === 4) {
              return h('div', '增值税电子专用发票')
            } else if (billType === 5) {
              return h('div', '增值税电子普通发票')
            }
          }
        },
        {
          title: '收款',
          resizable: true,
          key: 'receptDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [
            { label: '未收款', value: 0 },
            { label: '已收款', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.receptFilter = genQueryParam('receptDatetime', 'NNULL', null)
              } else {
                this.receptFilter = genQueryParam('receptDatetime', 'EQNULL', null)
              }
            } else {
              this.receptFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.receptDatetime) {
              let d = new Date(params.row.receptDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未收款')
            }
          }
        },
        // {
        //   title: '回访状态',
        //   key: 'callingFeedback',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   minWidth: 180,
        //   render: function (h, params) {
        //     let callingFeedback = params.row.callingFeedback
        //     if(callingFeedback === 1){
        //       return h('div', {
        //         style:{
        //           color:'red'
        //         }
        //       }, '未回访')
        //     }else if(callingFeedback === 2){
        //       return h('div', {
        //         style:{
        //           color:'red'
        //         }
        //       }, '未能联系客户')
        //     }else if(callingFeedback === 3){
        //       return h('div', {
        //         style:{
        //           color:'green'
        //         }
        //       }, '回访完成')
        //     }
        //   }
        // },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '销售渠道',
          resizable: true,
          key: 'salesChannelId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.salesChannelFilter = []
              val.forEach(item => {
                this.salesChannelFilter.push(genQueryParam('salesChannelId', 'EQ', item))
              })
            } else {
              this.salesChannelFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.salesChannel) {
              return h('div', params.row.salesChannel.name)
            }
          }
        },
        {
          title: '业务类型',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100,
          render: function (h, params) {
            let businessType = params.row.businessType
            if (businessType === 1) {
              return h('div', '新装')
            } else if (businessType === 2) {
              return h('div', '接入')
            } else if (businessType === 3) {
              return h('div', '在网升级')
            }
          }
        },
        {
          title: '订单类型',
          resizable: true,
          key: 'isfree',
          ellipsis: 'true',
          tooltip: 'true',
          width: 200,
          filters: [
            { label: '自费模式', value: 1 },
            { label: '普通免费模式', value: 2 },
            { label: '太好保模式', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.isfreeTypeFilter = []
              val.forEach(item => {
                this.isfreeTypeFilter.push(genQueryParam('isfree', 'EQ', item))
              })
            } else {
              this.isfreeTypeFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let isfree = params.row.isfree
            if (isfree === 1) {
              return h('div', '自费模式')
            } else if (isfree === 2) {
              return h('div', '普通免费模式')
            } else if (isfree === 3) {
              return h('div', '太好保模式')
            }
          }
        },
        {
          title: '设备详细',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDevice = null
            let positioningDeviceinfo = null
            if (params.row.positioningDevice != null) {
              positioningDevice = params.row.positioningDevice
            }
            let PositioningDeviceFittingsModel = null
            let newPositioningDeviceinfo = null
            if (params.row.newPositioningDeviceFittingsModel != null) {
              PositioningDeviceFittingsModel = params.row.newPositioningDeviceFittingsModel
            }
            if (positioningDevice) {
              positioningDeviceinfo = positioningDevice.positioningDeviceModel.name + '(' + new Date(positioningDevice.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (PositioningDeviceFittingsModel) {
              newPositioningDeviceinfo = PositioningDeviceFittingsModel.positioningDeviceModel.name + '(' + new Date(params.row.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (positioningDevice != null && PositioningDeviceFittingsModel != null) {
              return h('div', [
                h('div', '原设备:' + positioningDeviceinfo),
                h('div', '升级设备:' + newPositioningDeviceinfo)
              ])
            } else {
              let positioningDeviceInfos = null
              let positioningDeviceInfo = null
              if (params.row.positioningDeviceInfos) {
                positioningDeviceInfos = params.row.positioningDeviceInfos
                positioningDeviceInfo = positioningDeviceInfos[0].positioningDeviceModel.name + '(' + new Date(positioningDeviceInfos[0].serviceDatetime).Format('yyyy年MM月dd日') + ')'
              }
              if (positioningDeviceInfo) {
                return h('div', [
                  h('div', '设备:' + positioningDeviceInfo)
                ])
              } else {
                return h('div', [
                  h('div', '无')
                ])
              }
            }
          }
        },
        {
          title: '摄像头通道',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDeviceInfos = null
            if (params.row.positioningDeviceInfos) {
              positioningDeviceInfos = params.row.positioningDeviceInfos
            }
            var str = ''
            if (positioningDeviceInfos != null && positioningDeviceInfos.length > 0) {
              if (positioningDeviceInfos[0].aisleOne != null && positioningDeviceInfos[0].aisleOne) {
                str += '1-'
              }
              if (positioningDeviceInfos[0].aisleTwo != null && positioningDeviceInfos[0].aisleTwo) {
                str += '2-'
              }
              if (positioningDeviceInfos[0].aisleThree != null && positioningDeviceInfos[0].aisleThree) {
                str += '3-'
              }
              if (positioningDeviceInfos[0].aisleFour != null && positioningDeviceInfos[0].aisleFour) {
                str += '4-'
              }
              if (positioningDeviceInfos[0].aisleFive != null && positioningDeviceInfos[0].aisleFive) {
                str += '5-'
              }
              if (positioningDeviceInfos[0].aisleSix != null && positioningDeviceInfos[0].aisleSix) {
                str += '6-'
              }
              if (positioningDeviceInfos[0].aisleSeven != null && positioningDeviceInfos[0].aisleSeven) {
                str += '7-'
              }
              if (positioningDeviceInfos[0].aisleEight != null && positioningDeviceInfos[0].aisleEight) {
                str += '8-'
              }
              if (positioningDeviceInfos[0].aisleNine != null && positioningDeviceInfos[0].aisleNine) {
                str += '9-'
              }
              if (positioningDeviceInfos[0].aisleTen != null && positioningDeviceInfos[0].aisleTen) {
                str += '10-'
              }
            }
            str = str.substring(0, str.length - 1)
            // console.log(str)
            if (positioningDeviceInfos != null && positioningDeviceInfos[0].positioningDeviceModel.adas) {
              return h('div', [
                h('div', '通道:' + str)
              ])
            } else {
              return h('div', [
                h('div', '无')
              ])
            }
          }
        },
        {
          title: '配件列表',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'newPositioningDeviceFittingsModel',
          width: 260,
          render: function (h, params) {
            let str1 = ''
            let str2 = ''
            let PositioningDeviceFittings = params.row.newPositioningDeviceFittingsModel
            if (PositioningDeviceFittings) {
              if (PositioningDeviceFittings.starLightAlarm) {
                if (PositioningDeviceFittings.starLightAlarmType) {
                  str1 += PositioningDeviceFittings.starLightAlarmType.name + ','
                }
              }
              if (PositioningDeviceFittings.viewingScreen) {
                if (PositioningDeviceFittings.viewingScreenType) {
                  str1 += PositioningDeviceFittings.viewingScreenType.name + ','
                }
              }
              if (PositioningDeviceFittings.interphone) {
                if (PositioningDeviceFittings.interphoneType) {
                  str1 += PositioningDeviceFittings.interphoneType.name + ','
                }
              }
              if (PositioningDeviceFittings.trumpet) {
                if (PositioningDeviceFittings.trumpetType) {
                  str1 += PositioningDeviceFittings.trumpetType.name + ','
                }
              }
              if (PositioningDeviceFittings.hardDisk) {
                if (PositioningDeviceFittings.hardDiskType) {
                  str1 += PositioningDeviceFittings.hardDiskType.name + ','
                }
              }
              if (PositioningDeviceFittings.extensionCord) {
                if (PositioningDeviceFittings.extensionCordOneType) {
                  str1 += PositioningDeviceFittings.extensionCordOneType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordOneNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFiveType) {
                  str1 += PositioningDeviceFittings.extensionCordFiveType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFiveNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFifteenType) {
                  str1 += PositioningDeviceFittings.extensionCordFifteenType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFifteenNum + ','
                }
              }

              if (PositioningDeviceFittings.camera) {
                if (PositioningDeviceFittings.cameraOneType) {
                  str2 += PositioningDeviceFittings.cameraOneType.name
                  str2 += '*' + PositioningDeviceFittings.cameraOneNum + ','
                }
                if (PositioningDeviceFittings.cameraTwoType) {
                  str2 += PositioningDeviceFittings.cameraTwoType.name
                  str2 += '*' + PositioningDeviceFittings.cameraTwoNum + ','
                }
                if (PositioningDeviceFittings.cameraThreeType) {
                  str2 += PositioningDeviceFittings.cameraThreeType.name
                  str2 += '*' + PositioningDeviceFittings.cameraThreeNum + ','
                }
                if (PositioningDeviceFittings.cameraFourType) {
                  str2 += PositioningDeviceFittings.cameraFourType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFourNum + ','
                }
                if (PositioningDeviceFittings.cameraFiveType) {
                  str2 += PositioningDeviceFittings.cameraFiveType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFiveNum + ','
                }
              }
            }
            return h('div', [
              h('div', str1),
              h('div', str2)
            ])
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 400,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            if (params.row.businessType != 3) {
              if (params.row.vehicleInfoId) {
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderBaseDetailId = params.row.id
                        this.installOrderBaseDetailModal = true
                      }
                    }
                  }, '订单信息')
                )
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.vehicleInfoDetailId = params.row.vehicleInfoId
                        this.vehicleInfoDetailModal = true
                      }
                    }
                  }, '车辆信息')
                )
              } else {
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderDetailId = params.row.id
                        this.installOrderDetailModal = true
                      }
                    }
                  }, '详细信息')
                )
              }
            } else {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.installOrderBaseDetailId = params.row.id
                      this.installOrderBaseDetailModal = true
                    }
                  }
                }, '订单信息')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.vehicleInfoDetailId = params.row.vehicleInfoId
                      this.vehicleInfoDetailModal = true
                    }
                  }
                }, '车辆信息')
              )
            }

            // 新增，接入需要确认车辆资料
            if (params.row.uploadState !== 3) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认上传资料完成',
                        content: '<p>注意：确认上传资料完成后将不能恢复之前状态！！</p>',
                        onOk: () => {
                          store.dispatch('InstallOrderServ_ConfirmUpload', { params: { id: params.row.id } }).then(() => {
                            this.$Message.success('确认上传资料完成')
                            this.onSuccess()
                          }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '确认上传资料')
              )
            }
            // 没有收款时间，需要确认收款
            if (!params.row.receptDatetime) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.confirmReceptId = params.row.id
                      this.confirmReceptModal = true
                    }
                  }
                }, '确认收款')
              )
            }

            display.push(h('Dropdown',
              {
                props: {
                  transfer: true
                }
              },
              [h('Button', '更多'),
                h('DropdownMenu', { slot: 'list' }, [
                  // 车辆识别码，根据是否有车辆信息修改
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        if (params.row.vehicleInfoId) {
                          this.vehicleIdentificationcodeInstalled = true
                          this.vehicleIdentificationcodeId = params.row.vehicleInfoId
                        } else {
                          this.vehicleIdentificationcodeInstalled = false
                          this.vehicleIdentificationcodeId = params.row.id
                          this.vehicleIdentificationcodeModal = true
                        }
                      }
                    }
                  }, '车辆识别码'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.changeBusinessUserId = params.row.id
                        this.changeBusinessUserModal = true
                      }
                    }
                  }, '指派业务员'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.changeInstallerId = params.row.id
                        this.changeInstallerModal = true
                      }
                    }
                  }, '指派安装员'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        window.location.href = '/api/om/installorder/generatematerial/' + params.row.positioningDeviceInfos[0].id
                      }
                    }
                  }, '打印订单'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        if ((!params.row.vehicleInfo) || (!params.row.vehicleInfo.vehicleOwnerInfoId)) {
                          if ((!params.row.tempVehicleInfo) || (!params.row.tempVehicleInfo.vehicleOwnerInfoId)) {
                            this.$Message.error('缺少车辆所有人信息')
                            return
                          }
                        }
                        this.exportVehicleCertInstalled = false
                        this.exportVehicleCertId = params.row.id
                        this.exportVehicleCertModal = true
                      }
                    }
                  }, '导出证明'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.bindPositioningDevicesId = params.row.id
                        this.bindPositioningDevicesModal = true
                      }
                    }
                  }, '设备'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.bindPositioningDevicesFittingsId = params.row.id
                        this.bindPositioningDevicesFittingsModal = true
                      }
                    }
                  }, '配件'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        if (params.row.tempVehicleInfoId != null) {
                          this.tempVehiclePictureId = params.row.id
                          this.tempVehiclePictureModal = true
                        } else {
                          this.vehiclePictureId = params.row.vehicleInfoId
                          this.vehiclePictureModal = true
                        }
                      }
                    }
                  }, '资料图片'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.installOrderPictureModalId = params.row.id
                        this.installOrderPictureModal = true
                      }
                    }
                  }, '安装图片'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        if (params.row.reInstall) {

                        } else {
                          this.confirmInstalledId = params.row.id
                          this.confirmInstalledModal = true
                        }
                      }
                    }
                  }, '后台确认安装'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认作废订单',
                          content: '<p>注意：确认作废订单完成后将不能恢复之前状态！！</p>',
                          onOk: () => {
                            store.dispatch('InstallOrderServ_Cancel', { params: { id: params.row.id } }).then(() => {
                              this.$Message.success('确认作废订单完成')
                              this.onSuccess()
                            }).catch(err => {
                              this.$Message.error(err)
                              this.$emit('on-fail')
                            })
                          },
                          onCancel: () => {
                          }
                        })
                      }
                    }
                  }, '作废订单')
                ])])
            )
            return display
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'InstallOrderServ_GetPage'
    ]),
    rowClassName (row, index) {
      // if (row.bookingDatetime) {
      //   if (row.state == 1 || row.state == 2) {
      //     if (row.bookingDatetime + 86400000 < new Date().getTime()) {
      //       // console.log(row)
      //       // console.log(index)
      //       return 'demo-table-error-row'
      //     }
      //   }
      // }
      if (row.setupDatetime == null) {
        if (row.state != 2) {
          if (row.timeoutLogo) {
            return 'demo-table-error-row'
          } else {
            return ''
          }
        }
      }
    },
    onOkInsuranceVideoCommitment () {
      // let setupDatetime = null
      // if (this.installDatetime==null || this.installDatetime == ''){
      //   setupDatetime = null
      // }else {
      //   setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      // }
      // window.location.href = '/api/om/installorder/generateinsurancevideocommitment/' + this.setDatetimeId + '/' + setupDatetime + '/' + this.isall

      if (this.reqParams.installDatetime != null || this.reqParams.installDatetime != '') {
        this.reqParams.installDatetime = new Date(this.reqParams.installDatetime).getTime()
      } else {
        this.reqParams.installDatetime = null
      }
      axios.request({
        method: 'POST',
        url: '/om/installorder/generateinsurancevideocommitment',
        data: this.reqParams,
        responseType: 'blob'
      }).then(res => {
        let blob = res.data
        let reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          let a = document.createElement('a')

          let name = ''
          if (this.reqParams.registrationNum) {
            name = '保险承诺函：' + this.reqParams.registrationNum
          } else {
            name = '保险承诺函'
          }

          a.download = name + '.doc'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      }).catch((error) => {

      })
    },
    /**
     * 查询运营信息
     */
    inquireOperation () {
      console.log('查询运营资格')
      console.log(this.registrationNum)
      store.dispatch('VehicleInfoServ_InquireOperation', {
        params: {
          registrationNum: this.registrationNum
        }
      }).then(res => {
        console.log(store.getters.get_VehicleInfo_InquireOperationResult)
        if (store.getters.get_VehicleInfo_InquireOperationResult) {
        }
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装员') {
          this.columns[i].filters = this.installers
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    onFilterClick () {
      this.FilterClickFilter = null
      this.setPage(1)
    },
    DropdownonFilterClick (name) {
      this.FilterClickFilter = name
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      try {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let qo1 = null
        let qo2 = null
        let qo3 = null
        let qo4 = null
        let qo5 = null
        let qo6 = null
        let qo7 = null
        let qo8 = null
        let qo9 = null
        let qo10 = null
        let queryParams = []
        let sortParam = null

        if (this.sort) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        } else {
          sortParam = genSortParam('createDatetime', false)
        }
        if (this.stateFilter) {
          qo1 = this.stateFilter
        } else {
          qo1 = [genQueryParam('state', 'EQ', 1),
            genQueryParam('state', 'EQ', 2),
            genQueryParam('state', 'EQ', 3),
            genQueryParam('state', 'EQ', 4),
            genQueryParam('state', 'EQ', 5),
            genQueryParam('state', 'EQ', 6),
            genQueryParam('state', 'EQ', 7)]
        }
        if (this.installedFilter) {
          queryParams.push(this.installedFilter)
        }
        if (this.qghyptOptionFilter) {
          qo2 = this.qghyptOptionFilter
        }
        if (this.uploadStateFilter) {
          qo3 = this.uploadStateFilter
        }
        if (this.receptFilter) {
          queryParams.push(this.receptFilter)
        }
        if (this.installerFilter) {
          qo4 = this.installerFilter
        }
        if (this.businessUserFilter) {
          qo5 = this.businessUserFilter
        }
        if (this.billTypeFilter) {
          qo6 = this.billTypeFilter
        }
        if (this.gdcdgovVehicleStateFilter) {
          qo7 = this.gdcdgovVehicleStateFilter
        }
        if (this.salesChannelFilter) {
          qo8 = this.salesChannelFilter
        }
        if (this.isfreeTypeFilter) {
          qo9 = this.isfreeTypeFilter
        }
        if (this.timeoutLogoFilter) {
          qo10 = this.timeoutLogoFilter
        }
        if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
          let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          if (this.FilterClickFilter != null) {
            queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
          } else {
            queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
          }
        }

        store.dispatch('InstallOrderServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams,
            qo1: qo1,
            qo2: qo2,
            qo3: qo3,
            qo4: qo4,
            qo5: qo5,
            qo6: qo6,
            qo7: qo7,
            qo8: qo8,
            qo9: qo9,
            qo10: qo10,
            ps: this.pageFilter,
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      } catch (e) {
        console.log('setPage')
        console.log(e)
      }
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onTest () {
      store.dispatch('InstallOrderServ_OmTest', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('测试')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onImportOrders () {
      store.dispatch('InstallOrderServ_ImportOrders', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('导入')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onExportExcel () {
      let queryParams = []
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        queryParams.push(genQueryParam('createDatetime', 'BTDT', new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00'), new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')))
      }
      let urlparams = {
        // qo1: qo1,
        // qo2: qo2,
        q: queryParams
        // keyword: this.keywordFilter
      }
      window.location.href = '/api/om/installorder/getreport' + genURLParams(urlparams)
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_InstallOrder_GetPageResult) {
        return store.getters.get_InstallOrder_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_InstallOrder_GetPageResult) {
        return store.getters.get_InstallOrder_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_InstallOrder_GetPageResult) {
        return store.getters.get_InstallOrder_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.columns.forEach(item => {
      //   this.columnHeaders.push(item.title)
      //   this.columnsDisplay.push(item.title)
      // })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => {
          return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
          })
          // this.columns[4].filters = this.installers
          // this.columns[13].filters = this.marketsales
          store.dispatch('SalesChannelServ_GetAll', {
            params: null,
            urlparams: null
          }).then(() => {
            let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
            this.allSalesChannels = allSalesChannels.map(item => {
              return { label: item.name, value: item.id }
            })
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style>
  .ivu-table .demo-table-info-row td {
    background-color: #2db7f5;
    color: #fff;
  }

  .ivu-table .demo-table-error-row td {
    background-color: #82b455;
    color: #000000;
  }
</style>
